import React from 'react';
import { InfoTooltip } from './InfoTooltip';
interface FormFieldProps {
  label: string;
  required?: boolean;
  tooltip?: string;
  children: React.ReactNode;
}
export function FormField({
  label,
  required = false,
  tooltip,
  children
}: FormFieldProps) {
  return <div className="mb-4" data-id="element-528">
      <div className="flex items-center mb-1" data-id="element-529">
        <label className="block text-sm font-medium text-gray-700" data-id="element-530">
          {label} {required && <span className="text-red-500" data-id="element-531">*</span>}
        </label>
        {tooltip && <InfoTooltip content={tooltip} data-id="element-532" />}
      </div>
      {children}
    </div>;
}